import  { forwardRef } from "react";
import { Avatar } from '@mui/material'
import React from 'react'
import"./Post.css"
import VerifiedIcon from '@mui/icons-material/Verified';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import RepeatIcon from '@mui/icons-material/Repeat';
import PublishIcon from '@mui/icons-material/Publish';



const Post= forwardRef(
  ({
  displayName,
  username,
  verified,
  text,
  image,
  avatar},ref)=>{


  return (
    <div className='post'ref={ref}>
      <div className="post__avatar">
      <Avatar src={avatar}></Avatar>
      </div>
      <div className="post__body">
        <div className="post__header">
          <div className="post__headerText">
            <h3>
            {displayName}{" "}<span className='post__headerSpecial'>
            {verified && <VerifiedIcon className='post__badge'/>}
            @{username}
            </span>
            </h3>
          </div>
          <div className="post__headerDescription">
            <p>{text}
            </p>
          </div>
        </div>
        <img src={image} alt="" />
      <div className="post__footer">
        <ChatBubbleOutlineIcon className='Icon' fontSize="small"/>
        <RepeatIcon className='Icon' fontSize="small"/>
        <FavoriteBorderIcon className='Icon' fontSize="small"/>
        <PublishIcon  className='Icon' fontSize="small"/>

      </div>
      
      </div>


    </div>
  )
});

export default Post